import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/index.js'
import { getToken, setToken, removeToken,getLoadedMenu,setLoadedMenu} from '@/utils/auth'
import LayoutTB from '@/views/layout_tb/Index.vue'
import LayoutTLR from '@/views/layout_tlr/Index.vue'
import NotFound from '@/views/404.vue'

const homePage = '/back/map';

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router)

console.log('local_storage layout',localStorage.getItem('layout'));
const getLayout = ()=>{return localStorage.getItem('layout')=='layout_tlr'?LayoutTLR:LayoutTLR;}
const routes = [
  {path:'/login',component:()=>import('@/views/Login.vue')},
  {path:'/test/weigh',component:()=>import('@/views/test/Weigh.vue')},
  {path:'/test/driver-monitor',component:()=>import('@/views/test/DriverMonitor.vue')},
  {path:'/test/driver-task',component:()=>import('@/views/test/DriverTask.vue')},
  {path:'/back/dashboard',component:getLayout(),children:[{path:'',component:()=>import('@/views/back/Dashboard.vue')}]},
  {path:'/back/map',component:getLayout(),children:[{path:'',component:()=>import('@/views/back/map/MapView.vue')}]},
  {path:'/back/map/fence',component:getLayout(),children:[{path:'',component:()=>import('@/views/back/map/FenceDraw.vue')}]},
  {path:'/back/weigh/monitor',component:getLayout(),children:[{path:'',component:()=>import('@/views/back/weigh/Monitor.vue')}]},
  {path:'/back/analysis/tree_map',component:getLayout(),children:[{path:'',component:()=>import('@/views/back/analysis/EchartsTreeMap.vue')}]},
  {path:'*',component:NotFound},
];

const router = new Router({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes
});

const storeMenu = localStorage.getItem('vue_store_menu');
const storedRoutes = JSON.parse(storeMenu?storeMenu:'[]');
if (storedRoutes && storedRoutes.length > 0) {
  storedRoutes.forEach(r=>{
    let exists = false;
    const param = r.pageFile;
    router.getRoutes().forEach(n=>{if(n.path==r.url) exists=true;})
    if(!exists) router.addRoute({ path: r.url, component:getLayout(),children:[{path:'',name: r.resourceName + Math.random(), component:resolve => require([`@/views/${param}`], resolve)}] })
  });
}

router.beforeEach((to, from, next)=>{
  let user = localStorage.getItem('vue_store_user');
  const isLogin = user!=null&&getToken()!=null;
  
  // 为test路径添加白名单，不需要登录就能访问
  if (to.path.startsWith('/test/')) {
    next();
    return;
  }
  
  if (to.fullPath=='/'&&isLogin){next({path:homePage});return;}
  if (to.fullPath=='/login'&&isLogin){next({path:homePage});return;}
  if (to.fullPath=='/login'&&!isLogin){next();return;}
  if (!isLogin) {next({path:'/login'});return;}
  store.dispatch('reloadUser');
  if (store.state.user.id<=0) {if(to.path=='/login')next();else next({path:'/login'});return;}
  if (routes.length!=router.getRoutes().length) {next();return;}
  next();
})

router.afterEach((to, from) => {
  window.scrollTo(0,0);
})

router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = router.history.pending.fullPath;
  if (isChunkLoadFailed) {
    router.replace(targetPath);
  }
});

export default router;
